import { array, boolean, coerce, Describe, number, optional, string, type } from 'superstruct';

export type FetchNewsItem = {
  nid: string;
  title: string;
  meta_title: string;
  meta_description: string;
  meta_image: string;
  meta_image_crops: string;
  topics: number[];
  path: string;
  change_description: string;
  new_content: boolean;
};
export const FetchNewsItemValidator: Describe<FetchNewsItem> = type({
  nid: coerce(string(), number(), val => `${val}`),
  title: string(),
  meta_title: string(),
  meta_description: string(),
  meta_image: string(),
  meta_image_crops: string(),
  topics: array(number()),
  path: string(),
  change_description: string(),
  new_content: coerce(boolean(), number(), val => val === 1),
});

export type FetchNews = Array<FetchNewsItem>;
export const FetchNewsValidator: Describe<FetchNews> = array(FetchNewsItemValidator);

export type FetchPreferences = {
  topics: number[] | undefined;
};
export const FetchPreferencesValidator: Describe<FetchPreferences> = type({
  topics: optional(array(number())),
});

export type PostPreferences = boolean;
export const PostPreferencesValidator: Describe<PostPreferences> = boolean();
